export type AppEnvironment = 'local' | 'staging' | 'production';

/**
 * Which deployment the running webapp is: 'local' (a dev machine), 'staging' or
 * 'production'. Read from REACT_APP_CURRENT_ENV, which is set per Railway
 * deployment and baked in at build time; anything else — unset, 'development',
 * 'local' — counts as local dev.
 *
 * This describes where the app is served from, not which API it talks to: local
 * dev points at the staging API and is still 'local'.
 */
export default function getEnvironment(): AppEnvironment {
    const env = (process.env.REACT_APP_CURRENT_ENV || '').toLowerCase();
    if (env === 'production' || env === 'staging') {
        return env;
    }
    return 'local';
}
